import { batch as reactReduxBatch } from 'react-redux';
const isDevelopment = process.env.NODE_ENV === 'development';
export function batch(scope, callback) {
    let result;
    if (!callback) {
        reactReduxBatch(() => {
            result = scope();
        });
        return result;
    }
    if (isDevelopment) {
        console.groupCollapsed(`Batch ${scope}`);
    }
    try {
        reactReduxBatch(() => {
            result = callback();
        });
        return result;
    }
    finally {
        if (isDevelopment) {
            console.groupEnd();
        }
    }
}
//# sourceMappingURL=batch.js.map